import styled from 'styled-components/macro';

import { deviceMax } from 'utils/styles/breakpoints';
import { CONTAINERS } from 'utils/baseStyleSizes';

export const BaseContentContainer = styled.div`
  margin: 0 auto;
  max-width: ${CONTAINERS.contentContainer};

  @media ${deviceMax.laptopM} {
    max-width: ${CONTAINERS.contentContainerLaptopM};
  }

  @media ${deviceMax.tablet} {
    max-width: ${CONTAINERS.contentContainerTablet};
  }

  @media ${deviceMax.mobileL} {
    max-width: ${CONTAINERS.contentContainerMobileL};
  }
`;
